import { Gift, Users } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const LaunchBenefit = () => {
  const { t } = useLanguage();
  const c = t.credit;

  return (
    <div data-testid="launch-benefit" className="max-w-4xl mx-auto">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <span className="text-xs font-mono-spec text-gold-700 font-semibold tracking-wider uppercase">
          {c.benefitEyebrow}
        </span>
        <h2 className="text-3xl font-bold tracking-tight text-slate-950 mt-2" data-testid="launch-benefit-title">
          {c.benefitTitle}
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 gap-5">
        <div className="p-6 bg-white border spec-border rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.03)]" data-testid="launch-card-welcome">
          <div className="w-10 h-10 rounded-full bg-blue-50 border border-blue-200 flex items-center justify-center">
            <Gift className="text-blue-600" size={18} />
          </div>
          <h3 className="text-lg font-bold text-slate-950 mt-4">{c.card1Title}</h3>
          <p className="text-sm text-slate-600 mt-2 leading-relaxed">{c.card1Text}</p>
        </div>

        <div className="p-6 bg-white border spec-border rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.03)]" data-testid="launch-card-referral">
          <div className="w-10 h-10 rounded-full bg-blue-50 border border-blue-200 flex items-center justify-center">
            <Users className="text-blue-600" size={18} />
          </div>
          <h3 className="text-lg font-bold text-slate-950 mt-4">{c.card2Title}</h3>
          <p className="text-sm text-slate-600 mt-2 leading-relaxed">{c.card2Text}</p>
        </div>
      </div>

      <p className="mt-5 text-xs font-mono-spec text-slate-500 leading-relaxed text-center max-w-2xl mx-auto" data-testid="launch-disclaimer">
        {c.disclaimer}
      </p>

      <div className="mt-6 p-5 bg-slate-950 text-white rounded-2xl max-w-sm mx-auto" data-testid="launch-example">
        <div className="text-[10px] font-mono-spec text-slate-400 uppercase tracking-wider mb-3">{c.exampleTitle}</div>
        <dl className="space-y-2 text-sm">
          <div className="flex justify-between">
            <dt className="text-slate-300">{c.exampleCampaign}</dt>
            <dd className="font-mono-spec">€20</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-slate-300">{c.exampleWelcome}</dt>
            <dd className="font-mono-spec text-gold-400">€5</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-slate-300">{c.exampleReferral}</dt>
            <dd className="font-mono-spec text-gold-400">€5</dd>
          </div>
          <div className="flex justify-between border-t border-slate-800 pt-2 mt-2 font-bold">
            <dt>{c.exampleTotal}</dt>
            <dd className="font-mono-spec text-gold-500">€30</dd>
          </div>
        </dl>
        <p className="mt-3 text-[10px] font-mono-spec text-slate-500 leading-relaxed">{c.exampleNote}</p>
      </div>
    </div>
  );
};
